export default "__VITE_ASSET__DoccL6K___"